import { JobItemTypeEnum } from "@/lib/supabase/supabaseEnums";
import {
	JobItemEntityType,
	PatientEntityType,
	PractitionerEntityType,
} from "@/lib/supabase/supabaseTypes";
import { ClientEntityType } from "@/lib/supabase/supabaseTypes";
import { getPatientDisplayName, getProfileDisplayName } from "@/lib/utils/client-utils";

export const getPatientLine = (
	patient: PatientEntityType,
	client: ClientEntityType
) => {
	const patientCode = patient?.code ?? "";
	if (client.is_print_pat_code_only) {
		return patientCode;
	}
	const patientName = getPatientDisplayName(patient);
	const birthDate = patient?.birth_date
		? new Date(patient.birth_date).toLocaleDateString("de-DE", {
				day: "2-digit",
				month: "2-digit",
				year: "numeric",
			})
		: "";

	if (patientName.trim() && patientCode.trim() && birthDate.trim()) {
		return patientCode + ": " + patientName + " (" + birthDate + ")";
	} else if (patientName.trim() && patientCode.trim()) {
		return patientCode + ": " + patientName;
	} else if (patientName.trim() && birthDate.trim()) {
		return patientName + " (" + birthDate + ")";
	} else if (patientCode.trim() && birthDate.trim()) {
		return patientCode + " (" + birthDate + ")";
	} else if (patientName.trim()) {
		return patientName;
	} else if (patientCode.trim()) {
		return patientCode;
	} else if (birthDate.trim()) {
		return birthDate;
	}
};

export const getPractitionerLine = (practitioner: PractitionerEntityType) => {
	return getProfileDisplayName(practitioner);
};

export const allItemsHaveSameTp = (jobItems: JobItemEntityType[]) => {
	const tariffItems = jobItems.filter(
		(i) => i.type === JobItemTypeEnum.TARIFF
	);
	if (tariffItems.length === 0) {
		return true;
	}
	return tariffItems.every((i) => i.tp_value === tariffItems[0].tp_value);
};
